export default "__VITE_ASSET__CjBlZc1A__"